<template>
  <div class="create-order-wrapper">
    <div class="create-order-content" v-if="!requestingPin">
      <div class="show-navbar">
        <Navbar v-if="!isDesktop" />
        <NavbarDesktop
          v-else
          :action="action"
          :cart="cart.length"
          :cheksSelected="showAddToCart"
          :canCreate="canCreate"
          :currentMode="'inside'"
          :currentView="currentView"
          @onConfirmAction="desktopAcceptAction"
          @onDiscardAction="goBack"
        />
      </div>
      <div class="create-order-menu" v-if="currentView === 'menu'">
        <AddDish
          :menu="menu"
          ref="addDish"
          cart
          @add="onProductAdd"
          @select="
            (v) => {
              showAddToCart = v;
              if (v) action.type = 'product-selected';
              else action.type = 'selectDish';
            }
          "
          @cancel="switchToQueue"
        />
      </div>

      <div class="create-order-cart" v-if="currentView === 'cart'">
        <div class="cart-header">
          {{ $t('create_order.check_order') }}
        </div>
        <ItemList mode="edit" :list="cart" @changeQuantity="onChangeQuantity" />
        <!-- <QueueButton
          variant="serve"
          class="d-block m-auto"
          @click="sendOrder"
          v-if="canCreate"
        >{{ $t('create_order.confirm') }}</QueueButton>-->
        <div class="total-block">
          <h4 class="total">{{ $t("card.total") }}</h4>
          <span class="amount">{{ total }}{{ currency.symbol }}</span>
        </div>
      </div>
    </div>
    <div class="create-order-buttons" v-if="currentView === 'cart'">
      <img src="/icons/btn-back.svg" @click="goBack" class="btn-back" />
      <button
        v-if="canCreate"
        :disabled="busy_creating"
        class="add-to-cart green"
        @click="sendOrder"
      >
      <img src="../assets/loader.svg" class="busy-loading-icon" v-if="busy_creating">
        {{ $t("create_order.confirm") }}
    </button>
    </div>

    <div class="create-order-buttons" v-if="currentView === 'menu'">

      <img src="/icons/btn-back.svg" @click="goBack" class="btn-back" />
        <small v-if="!showAddToCart && !itemsCount > 0" class="info">
          {{ $t('create_order.choose_dish') }}
        </small>

      <button
        class="btn-back bars"
        @click="switchToMenu"
        v-if="currentView === 'cart' && mode == 'edit'"
      >
        <font-awesome-icon icon="bars" />
      </button>

      <button
        v-if="!showAddToCart && currentView !== 'menu'"
        class="btn-back"
        @click="switchToMenu"
      >
        <img src="/icons/back2.svg" alt />
      </button>

      <button
        class="add-to-cart"
        v-if="showAddToCart && currentView == 'menu'"
        @click="uiContinue"
      >{{ $t("add_dish.add_to_cart") }}</button>

      <button
        class="btn-cart"
        @click="switchToCart"
        v-if="currentView === 'menu' && itemsCount > 0 && !showAddToCart"
      >
        {{ $t('create_order.cart') }}
        <span class="amount" v-if="itemsCount > 0">({{ itemsCount }})</span>
      </button>
    </div>

    <div>
      <PINLogin
        ref="pinModal"
        @confirm="onPinEntered"
        @close="requestingPin = false"
        v-if="requestingPin"
      />
    </div>
  </div>
</template>

<style scoped>
.col-2,
.col-10 {
  padding: 0;
}

.col-2 {
  padding-left: 5.4vw;
}

.col-10 {
  padding-left: 2vw;
}

.add-to-cart.left {
  float: left;
  display: initial;
}

.green {
  background: #129b81 !important;
  color: #ededed !important;
}

.add-to-cart {
  height: auto;
  font-size: 2.2vh;
  float: right;
  background: #aeccc6;
  width: 80%;
  outline: none;
  border: none;
  line-height: normal;
  color: #1d1d1d;
  border-radius: 5vh;
}

.show-navbar {
  position: fixed;
  z-index: 11;
  width: 100%;
}

.btn-back {
  background: #e2223b;
  color: white;
  width: 6.2vh;
  height: 6.2vh;
  border-radius: 5vh;
  border: none;
}

.btn-back img {
  display: block;
  margin: 0 -0.5vh auto;
}

.btn {
  height: 5.2vh;
  font-size: 2vh;
  width: 80%;
  line-height: normal;
  color: #1d1d1d !important;
  box-shadow: 0px 4px 1px rgba(0, 0, 0, 0.25);
  border-radius: 5vh;
}

.bars {
  padding: 12px 20px;
}

.create-order-wrapper {
  background: #ededed;
}

.pt-15 {
  padding-top: 1.6vh;
}

.create-order-buttons {
  background: #1d1d1d;
  bottom: 0;
  padding: 1.3vh 3.2vh 2.6vh;
  z-index: 5;
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: fixed;
  left: 0;
}

img.img-status {
  width: 7.5vw;
  height: auto;
  margin-top: 1vh;
  position: relative;
}

.cart-header {
  background-color: #1d1d1b;
  color: #ededed;
  height: auto;
  display: flex;
  font-size: 2.5vh;
  padding: 2.8vh 3vh 2.8vh 3vh;
  line-height: initial;
  border-radius: 2.5vh 2.5vh 0px 0px;

  position: relative;
}

.amount {
  font-weight: 600;
  color: #ff5353;
  font-size: 1.8vh;
  vertical-align: baseline;
}

.btn-cart {
  background: #aeccc6;
  border-radius: 5vh;
  color: white;
  float: right;
  font-size: 2.3vh;
  color: #1d1d1d;
  height: auto;
  width: 80%;
  border: none;
}

.create-order-cart {
  width: 90vw;
  margin: 0 auto 22vh;
  top: 10vh;
  position: relative;
  background: #ededed;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

.total-block {
  padding: 0 3.2vh;
  margin-top: 2.5vh;
  padding-bottom: 2.5vh;
}

.total {
  display: inline-block;
  margin: 0 !important;
  font-size: 3vh;
  text-align: initial;
  padding-top: 0.9vh;
  line-height: 0.8;
}

.total-block span.amount {
  float: right;
  margin-top: 0vh;
  line-height: 0.8;
  font-size: 4.8vh;
  font-weight: 500;
  color: #1d1d1b;
}

.add-to-cart:disabled {
  background: #908f8d !important;
  color: #1d1d1b !important;
}

@media screen and (min-width: 768px) {
  .btn-back img {
    margin: 0 auto;
  }
  div.create-order-buttons {
    display: none;
  }
  .create-order-cart {
    top: 0;
    margin-top: 11.111vw;
    margin-bottom: 1.389vw;
    width: 23.264vw;
  }
}
</style>

<script>
import QueueAPI from "@/api/queue";
import AuthAPI from "@/api/auth";

import AddDish from "@/components/modals/AddDish.vue";
import ItemList from "@/components/item/ItemList.vue";
import QueueButton from "@/components/QueueButton.vue";

import Navbar from "@/components/Navbar.vue";
import NavbarDesktop from "@/components/NavbarDesktop.vue";

import PINLogin from "@/components/modals/Login.vue";

import moment from "moment";

import SharedQueueService from "@/services/shared";

import OrderHelpers from "@/services/order/helpers.js"

export default {
  data() {
    return {
      target: {
        section: 0,
        table: 0,
      },

      showAddToCart: false,

      cart: [],

      currentView: "menu",

      busy_creating: false,

      requestingPin: false,
      action: {
        type: "selectDish",
      },
    };
  },
  methods: {
    desktopAcceptAction() {
      if (this.canCreate && this.currentView == "cart") this.sendOrder();
      if (this.cart.length && this.action.type == "selectDish")
        this.switchToCart();
      else this.uiContinue();
    },
    uiContinue() {
      this.$refs.addDish.uiContinue();
    },
    goBack() {
      this.$refs.addDish.goBack();
    },
    onProductAdd(item) {
      this.cart.push(Object.assign({}, item));
    },
    onChangeQuantity(index, delta) {
      this.cart[index].quantity += delta;

      if (this.cart[index].quantity < 1) {
        this.cart.splice(index, 1);
      }
    },
    switchToMenu() {
      this.currentView = "menu";
    },
    switchToCart() {
      this.currentView = "cart";
    },
    switchToQueue() {
      this.$router.push("/orders");
    },
    switchToTableSelection() {
      this.$router.push("/create");
    },
    callCreateAPI() {
      if (this.busy_creating) return;

      this.busy_creating = true;
      QueueAPI.createOrder(this.cart, this.target.section, this.target.table)
        .then((data) => {
          this.switchToQueue();
          this.busy_creating = false;
        })
        .catch((error) => {
          alert(error);
          this.busy_creating = false;
        });
    },
    sendOrder() {
      if (this.$store.state.shared) {
        this.requestingPin = true;
      } else {
        this.callCreateAPI();
      }
    },
    goBack() {
      if (this.showAddToCart) {
        this.$refs.addDish.uiCancel();
      } else if (this.currentView == "cart") {
        this.switchToMenu();
      } else {
        this.switchToTableSelection();
      }
      //this.$refs.addDish.uiCancel();
    },
    onPinEntered(pin) {
      AuthAPI.loginSharedWaiter(pin)
        .then((data) => {
          SharedQueueService.updateStampTime();
          this.$store
            .dispatch("fetchWaiter")
            .then((ok) => {
              this.callCreateAPI();
            })
            .catch((error) => {
              this.$store.commit("setError", error);
            });
        })
        .catch((error) => {
          console.log(error);
          this.$refs.pinModal.playError();
        });
    },
  },
  mounted() {
    this.$store.dispatch("init");

    this.target.section = parseInt(this.$route.params.section);
    this.target.table = parseInt(this.$route.params.table);
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    itemsCount() {
      return this.cart.length;
    },
    today() {
      return moment().format("DD.MM / HH:mm");
    },
    canCreate() {
      let itemsAvailable = 0;

      this.cart.forEach((it) => {
        if (it.available) itemsAvailable++;
      });

      return itemsAvailable > 0 && this.cart.length > 0;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    menu() {
      return this.$store.state.menu;
    },
    currency() {
      return this.$store.state.currency;
    },
    total() {
      if (!this.cart || !this.cart.length) return 0;

      return OrderHelpers.computeOrderTotal({
        list: this.cart
      });
    }
  },
  components: {
    AddDish,
    Navbar,
    NavbarDesktop,
    ItemList,
    QueueButton,
    PINLogin,
  },
};
</script>
